<template>
    <div style="margin-top: -10px; ">
        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">{{buildingName}} / Expense Types</span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
          name: 'property',
          params: { buildingId: buildingId, buildingName: buildingName },
        }"><i class="fas fa-plus"></i></router-link>-->
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div class="row">

            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Add New Expense Type</span>
                    <router-link class="btn btn-table" :to="{name:'expensetype', params:{buildingId:buildingId}}"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>

        <div v-if="false" class="row" style="margin-left:1px;">
            <div class="col-6 col-sm-5 col-md-3 search" style="width:245px; margin-bottom:11px">
                <span class="fa fa-search"></span>
                <input type="text"
                       class="form-control"
                       name="searchText"
                       id="searchText"
                       placeholder="Search Expense Types"
                       v-model="filter" />
            </div>
            <div class="col-12 col-sm-7 col-md-9 pullLeft" style="margin-top:-11px; text-align:right">
                <router-link class="btn btn-primary"
                             :to="{name:'expensetype', params:{buildingId:buildingId}}">Add Expense Type</router-link>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col" style="width:32%">No</th>
                        <th style="width:32%" scope="col">Name</th>
                        <th style="width:32%" scope="col">VAT Percentage</th>
                        <th style="width:4%" scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(expenseType, key) in getExpenseTypes"
                        :key="expenseType.id"
                        class="clickable-row">
                        <td scope="row" class="clickable-column">
                            <a @click.prevent="editItem(expenseType)">{{ ++key }}</a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="editItem(expenseType)">{{ expenseType.name}}</a>
                        </td>
                        <td class="clickable-column">
                            <a @click.prevent="editItem(expenseType)">{{ expenseType.vatPercentage}}</a>
                        </td>
                        <td>
                            <a class="btn btn-table" @click.prevent="deleteItem(expenseType)"><i class="fas fa-times"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- MODAL IS HERE -->
        <modal :scrollable="true"
               name="deleteAlert"
               @before-open="beforeOpen"
               height="auto"
               :minHeight="150"
               width="400">
            <div class role="document">
                <div class>
                    <!-- Modal content-->
                    <deleteAlert v-on:close="modalClosed"
                                 :entity-id="selectedExpenseTypeId"
                                 request="expenseTypes"
                                 entity="expenseType" />
                </div>
            </div>
        </modal>
    </div>
</template>
<style scoped>
@media (max-width: 599px) {
  .pullLeft {
    text-align: left !important;
    margin-left: -11px;
  }
}
</style>
<script>
import { mapState } from "vuex";
import { expenseTypeService } from "@/_services";
export default {
  data: function () {
    return {
      filter: "",
      expenseTypes: [],
      visibleSearch: false,
      buildingId: 0,
      selectedExpenseTypeId: 0,
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //this.buildingName = this.$route.params.buildingName;
    this.fetchStatement();
  },
  // directives:{
  //         confirm:{
  //             deleted:function(){
  //                 this.deleteAlert();
  //             }
  //         }
  //     },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getExpenseTypes() {
      var expenseTypes = this.expenseTypes.filter((expenseType) => {
        return expenseType.name
          .toLowerCase()
          .includes(this.filter.toLowerCase());
      });

      return expenseTypes;
    },
  },
  methods: {
    showSearch() {
      this.visibleSearch = !this.visibleSearch;
    },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      expenseTypeService
        .getExpenseTypesOfBuilding(this.buildingId)
        .then((response) => {
          this.mute = false;
          console.log(response.expenseTypes);
          //this.contacts = data.contacts;
          this.expenseTypes = response.expenseTypes;
        });
    },
    editItem: function (item) {
      this.$router.push({
        name: "expensetype",
        params: {
          id: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },

    modalClosed: function (itemDeleted) {
      if (itemDeleted) this.fetchStatement();
    },
    deleteItem: function destroy(item) {
      this.selectedExpenseTypeId = item.id;
      this.deleteAlert();
    },

    deleteAlert: function () {
      this.$modal.show("deleteAlert");
    },
  },
};
</script>